import { apiErrorHandler } from '../errorHandler'

export async function apiLogout(): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/logout`, {
    method: 'POST',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
